import { Product, SalesPackage } from '../types';

export const AddressActions = {
  SELECT_VALID_ADDRESS: 'SELECT_VALID_ADDRESS'
};

export const SalesApiAuthActions = {
  TOKEN_SET: 'TOKEN_SET',
  TOKEN_RESET: 'TOKEN_RESET'
};

export const PackagesActions = {
  FETCH_PACKAGES_INIT: 'FETCH_PACKAGES_INIT',
  FETCH_PACKAGES_SUCCESS: 'FETCH_PACKAGES_SUCCESS',
  FETCH_PACKAGES_ERROR: 'FETCH_PACKAGES_ERROR',
  SELECT_PACKAGE: 'SELECT_PACKAGE',
  RESET_PACKAGE: 'RESET_PACKAGE',
  SET_5GANTENNA: 'SET_5GANTENNA'
};

export const AdditionalProductActions = {
  SELECT_ADDITIONAL_PRODUCT: 'SELECT_ADDITIONAL_PRODUCT',
  DESELECT_ADDITIONAL_PRODUCT: 'DESELECT_ADDITIONAL_PRODUCT',
  RESET_SELECTED_ADDITIONAL_PRODUCTS: 'RESET_SELECTED_ADDITIONAL_PRODUCTS'
};

export const SalesActions = {
  COMMIT_SALE_INIT: 'COMMIT_SALE_INIT',
  COMMIT_SALE_SUCCESS: 'COMMIT_SALE_SUCCESS',
  COMMIT_SALE_ERROR: 'COMMIT_SALE_ERROR'
};

export const UpdateCustomerActions = {
  UPDATE_CUSTOMER_INIT: 'UPDATE_CUSTOMER_INIT',
  UPDATE_CUSTOMER_SUCCESS: 'UPDATE_CUSTOMER_SUCCESS',
  UPDATE_CUSTOMER_ERROR: 'UPDATE_CUSTOMER_ERROR'
};

export interface Action {
  type: string;
}

export interface AuthAction extends Action {
  payload: string;
}

export interface FetchPackageAction extends Action {
  payload: SalesPackage[];
}
export interface SetPackageAction extends Action {
  payload: SalesPackage;
}

export interface SalesAction extends Action {
  payload?: string;
}

export interface SetAdditionalProduct extends Action {
  payload: Product;
}

export interface UpdateCustomerAction extends Action {}

export interface SelectValidAddress {
  type: 'SELECT_VALID_ADDRESS';
  address: AddressLookup;
  isBate: boolean;
}

export type AddressAction = SelectValidAddress;

export interface AddressLookup {
  id: AddressId;
  postalCode: string;
  postalRegion: string;
  streetName: string;
  /* can surprisingly be null - see for instance HVAMMEN, 3630 */
  streetNumber: number | null;
  streetLetter: string | null;
  apartment: string | null;
  floor: string | null;
}

export type Opaque<K, T> = T & { __TYPE__: K };

export type AddressId = Opaque<'AddressId', number>;
export const AddressId = (num: number): AddressId => num as any;

export const selectValidAddress = (address: AddressLookup, isBate: boolean): SelectValidAddress => ({
  type: 'SELECT_VALID_ADDRESS',
  address,
  isBate
});
